const isRTL = () => document.querySelector('html').getAttribute('dir') === 'rtl';

export { isRTL };
